import { isValidUrl } from "@elixir/utils";
import { RadioButton, InputField } from "ui";
import { useState } from "react";
import useTeleConfigurationStore from "../../../../../stores/vc-meta-store";
import { SupportedTeleProviders } from "@elixir/types";
import { ReactComponent as MeetLogo } from "../../../../../assets/icons/custom/meetLogoTele.svg";
import { ReactComponent as ZoomLogo } from "../../../../../assets/icons/custom/zoomLogoTele.svg";
import { ReactComponent as TeamsLogo } from "../../../../../assets/icons/custom/teamsLogoTele.svg";

const platformIconMap: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  meet: MeetLogo,
  zoom: ZoomLogo,
  teams: TeamsLogo,
};

function getPlatformMatch(raw = "") {
  const lower = raw.toLowerCase();
  return (
    Object.entries(platformIconMap).find(([key]) => lower.includes(key))?.[1] ||
    null
  );
}

function OtherTelePlatform() {
  const platform = useTeleConfigurationStore((state) => state.platform);
  const setPlatform = useTeleConfigurationStore((state) => state.setPlatform);
  const meetLink = useTeleConfigurationStore((state) => state.meetLink);
  const setMeetLink = useTeleConfigurationStore((state) => state.setMeetLink);

  const [error, setError] = useState<string | undefined>();
  const MatchedIcon = getPlatformMatch(meetLink);

  return (
    <>
      <RadioButton
        isSelected={platform === SupportedTeleProviders.other}
        label="Other"
        onClick={() => {
          if (platform === SupportedTeleProviders.other) return;
          setPlatform(SupportedTeleProviders.other);
        }}
      />
      {platform === SupportedTeleProviders.other ? (
        <InputField
          prefixText="Meet URL"
          name="other-meet-url"
          helperText="Include the meeting URL to join the video call"
          className="dr-py-12 dr-px-14"
          placeholder="Enter Link"
          isMandatory
          onChange={(e) => {
            const val = e.target.value;
            setMeetLink(val);
            setError(undefined);
          }}
          value={meetLink}
          onBlur={({ value }) => {
            if (!isValidUrl(value)) {
              setError("Invalid URL");
            }
          }}
          error={error}
          customPrefix={
            <div className="dr-flex dr-items-center dr-bg-darwin-neutral-50 dr-px-12 dr-py-10 dr-h-full dr-rounded-l-8 dr-space-x-6">
              <div className="dr-text-darwin-neutral-1000 BodyRegular">
                Meet URL
              </div>
              {MatchedIcon ? <MatchedIcon className="dr-w-16 dr-h-16" /> : null}
            </div>
          }
        />
      ) : null}
    </>
  );
}

export default OtherTelePlatform;
